<template>
  <transition name="splash-fade">
    <div v-if="visible" class="splash">
      <div class="splash__bg">
        <div class="s-blob s-blob--1"></div>
        <div class="s-blob s-blob--2"></div>
        <div class="s-blob s-blob--3"></div>
      </div>

      <div class="splash__content">
        <div class="heart-stack">
          <div class="heart heart--pulse">
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 34s-12-7.4-12-16a7 7 0 0 1 12-4.9A7 7 0 0 1 32 18c0 8.6-12 16-12 16z"
                    fill="url(#sg1)"/>
              <defs>
                <linearGradient id="sg1" x1="8" y1="8" x2="32" y2="34">
                  <stop stop-color="#ff4d8d"/>
                  <stop offset="1" stop-color="#a020f0"/>
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div class="heart heart--ring"></div>
          <div class="heart heart--ring heart--ring-2"></div>
        </div>

        <div class="splash__brand">KissMora</div>
        <div class="splash__tag">{{ message }}</div>

        <div class="splash__bar">
          <div class="splash__bar-fill"></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SplashLoader',
  props: {
    // how long to show (ms). Pass 0 to keep it visible until you toggle.
    duration: { type: Number, default: 1500 },
    message: { type: String, default: 'Finding your connections…' }
  },
  data(){ return { visible: true }; },
  mounted(){
    if(this.duration > 0){
      setTimeout(() => { this.visible = false; this.$emit('done'); }, this.duration);
    }
  },
  methods: {
    hide(){ this.visible = false; this.$emit('done'); }
  }
}
</script>

<style scoped>
.splash {
  position: fixed; inset: 0; z-index: 9999;
  display: flex; align-items: center; justify-content: center;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", sans-serif;
  background:
    radial-gradient(1200px 800px at 20% 10%, rgba(255,77,141,.9), transparent 55%),
    radial-gradient(1200px 800px at 80% 90%, rgba(160,32,240,.9), transparent 55%),
    linear-gradient(135deg, #1a1033 0%, #4a1a6e 100%);
  overflow: hidden;
}
.splash__bg { position: absolute; inset: 0; overflow: hidden; }
.s-blob {
  position: absolute; border-radius: 50%; filter: blur(60px); opacity: .55;
  animation: sFloat 8s ease-in-out infinite;
}
.s-blob--1 { width: 400px; height: 400px; background: #ff4d8d; top: -100px; left: -100px; }
.s-blob--2 { width: 350px; height: 350px; background: #a020f0; bottom: -80px; right: -80px; animation-delay: -3s; }
.s-blob--3 { width: 280px; height: 280px; background: #ffb3d1; top: 40%; right: 10%; animation-delay: -6s; }
@keyframes sFloat {
  0%, 100% { transform: translate(0,0) scale(1); }
  50% { transform: translate(40px,-30px) scale(1.08); }
}

.splash__content {
  position: relative; z-index: 1;
  display: flex; flex-direction: column; align-items: center; gap: 16px;
  color: #fff;
}

.heart-stack {
  position: relative; width: 120px; height: 120px;
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 8px;
}
.heart { position: absolute; }
.heart--pulse {
  width: 80px; height: 80px;
  animation: heartBeat 1.2s ease-in-out infinite;
  filter: drop-shadow(0 10px 30px rgba(255,77,141,.5));
}
.heart--pulse svg { width: 100%; height: 100%; }
.heart--ring {
  width: 100px; height: 100px; border: 3px solid rgba(255,255,255,.4);
  border-radius: 50%; animation: ringPulse 1.8s ease-out infinite;
}
.heart--ring-2 { animation-delay: -.9s; }
@keyframes heartBeat {
  0%, 100% { transform: scale(1); }
  15%      { transform: scale(1.2); }
  30%      { transform: scale(1); }
  45%      { transform: scale(1.15); }
  60%      { transform: scale(1); }
}
@keyframes ringPulse {
  0%   { transform: scale(.8); opacity: .7; border-width: 3px; }
  100% { transform: scale(1.8); opacity: 0; border-width: 1px; }
}

.splash__brand {
  font-size: 42px; font-weight: 800; letter-spacing: -.02em;
  background: linear-gradient(90deg, #fff 0%, #ffd3e4 100%);
  -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent;
}
.splash__tag { font-size: 15px; opacity: .85; letter-spacing: .02em; }

.splash__bar {
  width: 180px; height: 4px; border-radius: 2px;
  background: rgba(255,255,255,.15); overflow: hidden; margin-top: 16px;
}
.splash__bar-fill {
  width: 40%; height: 100%;
  background: linear-gradient(90deg, #ff4d8d, #fff, #a020f0);
  border-radius: 2px;
  animation: barSlide 1.4s ease-in-out infinite;
}
@keyframes barSlide {
  0%   { transform: translateX(-100%); }
  100% { transform: translateX(350%); }
}

/* fade out */
.splash-fade-leave-active { transition: opacity .5s ease, transform .5s ease; }
.splash-fade-leave-to { opacity: 0; transform: scale(1.04); }

@media (max-width: 520px) {
  .splash__brand { font-size: 34px; }
  .splash__tag { font-size: 13px; padding: 0 24px; text-align: center; }
  .heart--pulse { width: 70px; height: 70px; }
  .heart--ring { width: 90px; height: 90px; }
}
</style>
